export default __webpack_public_path__ + "static/media/TVS.f848f616.webp";